import { useEffect, useRef } from 'react';
import TrackingLine from './components/TrackingLine';

interface CrossSectionChartProps {
    mousePosition?: number,
    onMouseOver: (value: number) => void
}

const OFFSET_VALUES = [6, 1, 30, 26];

function CrossSectionChart({
  mousePosition = 0,
  onMouseOver,
}: CrossSectionChartProps) {
  const chartImage = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const element = chartImage.current;
    const onMouseMove = (e: MouseEvent) => {
      const chartWidth = chartImage.current?.width || 0;
      const realWidth = chartWidth - OFFSET_VALUES[3];
      if (e.offsetX > OFFSET_VALUES[3]) {
        onMouseOver(Math.round(((e.offsetX - OFFSET_VALUES[3]) * 100) / realWidth));
      }
    };
    if (chartImage?.current) {
      element?.addEventListener('mousemove', onMouseMove);
    }

    return () => {
      if (element) {
        element.removeEventListener('mousemove', onMouseMove);
      }
    };
  }, [onMouseOver]);

  return (
    <>
      <TrackingLine
        height={chartImage.current?.height}
        width={chartImage.current?.width || 400}
        offset={OFFSET_VALUES}
        position={mousePosition}
      />
      <img src={`${process.env.PUBLIC_URL}/img/reflexibity-cross-section-example.png`} alt="example" ref={chartImage} />
    </>
  );
}

export default CrossSectionChart;
